<template>
  <a-dropdown :trigger="['click']" placement="bottomCenter">
    <span class="action" :title="$t('语言')">
      <a-icon type="global" />
      <span v-if="currentLabel">&nbsp;{{ currentLabel }}</span>
      <a-icon type="down" />
    </span>
    <a-menu slot="overlay" :selected-keys="[current]" @click="onChange">
      <a-menu-item v-for="lang in supportLangs" :key="lang.value">{{ lang.label }}</a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
// 语言切换入口：下拉选项遍历 src/i18n/index.js 的 SUPPORT_LANGS 注册表生成，
// 新增语言时仅需在注册表中加一行，本组件无需改动
import { SUPPORT_LANGS } from '@/i18n'

export default {
  name: 'LanguageSwitch',
  computed: {
    supportLangs: () => SUPPORT_LANGS,
    current() {
      return this.$store.state.app.language
    },
    currentLabel() {
      const conf = SUPPORT_LANGS.find(l => l.value === this.current)
      return conf ? conf.label : ''
    }
  },
  methods: {
    onChange({ key }) {
      if (key !== this.current) {
        this.$store.commit('SET_LANGUAGE', key)
      }
    }
  }
}
</script>
